import { render, staticRenderFns } from "./checkout-timer.vue?vue&type=template&id=60be8dfa&scoped=true"
import script from "./checkout-timer.vue?vue&type=script&lang=js"
export * from "./checkout-timer.vue?vue&type=script&lang=js"
import style0 from "./checkout-timer.vue?vue&type=style&index=0&id=60be8dfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60be8dfa",
  null
  
)

export default component.exports